<template>
    <footer class="footer">
        <div class="footer__shout" v-if="type === 'signin'">
            <h3 class="footer__heading">
                Already a member?
            </h3>
            <router-link class="footer__shout-link" to="/">Sign in here</router-link>
            <p class="footer__shout-text">
                Having problems or want help?
            </p>
            <a class="footer__shout-link" :href="helpURL">Account help</a>
        </div>

        <template v-else-if="type === 'help'"> </template>

        <section class="footer__partners">
            <div class="footer__container">
                <div class="crest-rule">
                    <span class="crest-rule__line"></span>
                    <img
                        class="crest-rule__crest"
                        src="../assets/logo.svg"
                        :alt="configStrings.clubName + ' crest'"
                    />
                    <span class="crest-rule__line"></span>
                </div>

                <div
                    class="partners"
                    v-for="(row, index) in partnerRows"
                    :key="index"
                >
                    <h2 class="partners__title" v-if="row.title">
                        {{ row.title }}
                    </h2>
                    <ul
                        class="partners__list"
                        :class="[
                            'partners__list--' + row.size,
                            'partners__list--' + row.align,
                        ]"
                    >
                        <li
                            class="partners__item"
                            v-for="partner in row.items"
                            :key="partner.name"
                        >
                            <a
                                class="partners__link"
                                :href="partner.url"
                                target="_blank"
                                rel="noopener noreferrer sponsored"
                            >
                                <img
                                    class="partners__logo"
                                    v-if="partner.logo"
                                    :src="partner.logo"
                                    :alt="partner.name"
                                    loading="lazy"
                                />
                                <span class="partners__placeholder" v-else>
                                    {{ partner.name }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="footer__social">
            <ul class="social">
                <li class="social__item" v-for="channel in socialChannels" :key="channel.name">
                    <a
                        class="social__link"
                        :href="channel.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        :title="channel.name"
                    >
                        <svg
                            class="social__icon"
                            viewBox="0 0 24 24"
                            role="img"
                            focusable="false"
                        >
                            <path :d="channel.path" />
                        </svg>
                    </a>
                </li>
            </ul>
        </section>

        <div class="footer__legal">
            <ul class="legal__links">
                <li class="legal__item" v-for="link in legalLinks" :key="link.label">
                    <a class="legal__link" :href="link.url">{{ link.label }}</a>
                </li>
            </ul>
            <p class="legal__copyright">
                &copy; {{ year }} {{ configStrings.clubName }} FC
            </p>
        </div>
    </footer>
</template>

<script>
const IMAGE_BASE = "https://images.gc.avfcservices.co.uk/fit-in/600x600/";

const partner = (name, url, imageKey) => ({
    name,
    url,
    logo: imageKey ? IMAGE_BASE + imageKey : null,
});

export default {
    name: "FooterShout",
    data() {
        var d = new Date();
        return {
            helpURL: "https://www.avfc.co.uk/fans/digital-membership",
            year: d.getFullYear(),
            partnerRows: [
                {
                    title: "Principal Partners",
                    size: "large",
                    align: "center",
                    items: [
                        partner(
                            "adidas",
                            "https://www.adidas.co.uk/football-shoes",
                            "e81c2d50-6345-11f1-848d-9be6f90b1605.png"
                        ),
                        partner(
                            "Visit Rwanda",
                            "https://visitrwanda.com/",
                            "3d71ceb0-841e-11f1-84c1-996dc5c6f04f.png"
                        ),
                        partner(
                            "Betano",
                            "https://www.betano.co.uk/",
                            "bed0e350-6345-11f1-bf40-ef2bee41eff1.png"
                        ),
                    ],
                },
                {
                    title: "Official Partners",
                    size: "small",
                    align: "spread",
                    items: [
                        partner(
                            "Sports Illustrated Tickets",
                            "https://www.destinationvillapark.com/the-warehouse/",
                            "e59c4210-8698-11f1-a409-eb127ad38071.png"
                        ),
                        partner(
                            "Coca-Cola",
                            "https://www.coca-cola.com/gb/en",
                            "877f5ef0-6349-11f1-acba-1151142d54e3.png"
                        ),
                        partner(
                            "Guinness",
                            "https://www.guinness.com/en-gb",
                            "8780be80-6349-11f1-bcf9-37b5029fd677.png"
                        ),
                        partner(
                            "Carlsberg Britvic",
                            "https://www.carlsbergmarstons.co.uk/",
                            "87809770-6349-11f1-ac83-633e5dfe7550.png"
                        ),
                        partner(
                            "Xapo Bank",
                            "https://www.xapobank.com/en",
                            "08224770-634a-11f1-bcf9-37b5029fd677.png"
                        ),
                        partner(
                            "Nemiroff",
                            "https://nemiroff.vodka/en-uk/",
                            "e21dc9d0-a68c-11ef-8bc4-2b744177df40.png"
                        ),
                    ],
                },
                {
                    title: null,
                    size: "small",
                    align: "spread",
                    items: [
                        partner(
                            "Ebury",
                            "https://ebury.com/",
                            "8778cf40-6349-11f1-8255-f99c8df6e2f7.png"
                        ),
                        partner(
                            "$AVL by Socios.com",
                            "https://www.fantokens.com/trade/aston-villa-fan-token",
                            "8a417a40-634b-11f1-bcf9-37b5029fd677.png"
                        ),
                        partner(
                            "eSentire",
                            "https://www.esentire.com/",
                            "87799290-6349-11f1-895c-cbef93f6404b.png"
                        ),
                        partner(
                            "JD Sports",
                            "https://www.jdsports.co.uk/search/aston+villa/",
                            "cfe42b10-634b-11f1-bcf9-37b5029fd677.png"
                        ),
                        partner(
                            "Fanatics",
                            "https://shop.avfc.co.uk/en/?_s=bm-FI-PSC-AVFC-Footer",
                            "03152de0-634c-11f1-bcf9-37b5029fd677.png"
                        ),
                        partner(
                            "SeatGeek",
                            "https://seatgeek.com/",
                            "355bf7c0-634c-11f1-bcf9-37b5029fd677.png"
                        ),
                    ],
                },
                {
                    title: null,
                    size: "small",
                    align: "spread",
                    items: [
                        partner(
                            "8Xbet",
                            "https://www.avfc.co.uk/news/2026/august/28/news-villa-launch-8xbet-partnership/",
                            "69455790-a878-11f1-b9a4-630aab9f460d.png"
                        ),
                        partner(
                            "NordVPN",
                            "https://nordvpn.com/sports-partner/?coupon=UTV&utm_medium=affiliate&utm_content=Web&utm_source=aff150703&utm_campaign=off439",
                            "c22b5550-948f-11f1-b281-35ca3e8fb469.png"
                        ),
                        partner(
                            "EA Sports FC",
                            "https://www.ea.com/games/ea-sports-fc/fc-27",
                            "b5d57350-a879-11f1-8241-171558c89823.png"
                        ),
                        partner(
                            "Sportsbet.io",
                            "https://www.avfc.co.uk/partners",
                            "e3054c00-9d6c-11f1-b87f-c3fea33bb95b.png"
                        ),
                        partner(
                            "Villa Win",
                            "https://www.villawin.co.uk/",
                            "69997590-a879-11f1-8241-171558c89823.png"
                        ),
                    ],
                },
                {
                    title: "Charity Partners",
                    size: "small",
                    align: "center",
                    items: [
                        partner(
                            "Acorns Children's Hospice",
                            "https://www.acorns.org.uk/",
                            "e4d2fc20-634d-11f1-9184-ad168233bfdf.png"
                        ),
                        partner(
                            "Birmingham Children's Hospital Charity",
                            "https://bwc.nhs.uk/birmingham-childrens-hospital",
                            "f9aecc50-634d-11f1-9184-ad168233bfdf.png"
                        ),
                        partner(
                            "Aston Villa Foundation",
                            "https://www.avfc.co.uk/foundation/",
                            "0ff1cda0-634e-11f1-9184-ad168233bfdf.png"
                        ),
                    ],
                },
            ],
            legalLinks: [
                {
                    label: "Terms of Use",
                    url: "https://www.avfc.co.uk/club/legal/acceptable-use-policy/",
                },
                {
                    label: "Privacy Policy",
                    url: "https://www.avfc.co.uk/club/legal/privacy-policy/",
                },
                {
                    label: "Accessibility",
                    url: "https://www.avfc.co.uk/club/legal/accessibility/",
                },
                {
                    label: "Cookie Policy",
                    url: "https://www.avfc.co.uk/club/legal/cookie-policy/",
                },
                {
                    label: "Diversity and Inclusion",
                    url: "https://www.avfc.co.uk/club/equality-diversity",
                },
            ],
            socialChannels: [
                {
                    name: "Threads",
                    url: "https://www.threads.com/@astonvilla",
                    path:
                        "M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142c-.126-.742-.375-1.332-.75-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.844 0-1.992.232-2.721 1.32L7.734 7.847c.98-1.454 2.568-2.256 4.478-2.256h.044c3.194.02 5.097 1.975 5.287 5.388.108.046.216.094.321.142 1.49.7 2.58 1.761 3.154 3.07.797 1.82.871 4.79-1.548 7.158-1.85 1.81-4.094 2.628-7.277 2.65Zm1.003-11.69c-.242 0-.487.007-.739.021-1.836.103-2.98.946-2.916 2.143.067 1.256 1.452 1.839 2.784 1.767 1.224-.065 2.818-.543 3.086-3.71a10.5 10.5 0 0 0-2.215-.221z",
                },
                {
                    name: "Spotify",
                    url: "https://open.spotify.com/show/2BfKUrvNgDoGY3obtbed0t?si=8ed09001d1b5416d",
                    path:
                        "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z",
                },
                {
                    name: "Facebook",
                    url: "https://www.facebook.com/astonvilla",
                    path:
                        "M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z",
                },
                {
                    name: "Instagram",
                    url: "https://www.instagram.com/astonvilla/",
                    path:
                        "M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077",
                },
                {
                    name: "X",
                    url: "https://x.com/AstonVilla",
                    path:
                        "M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z",
                },
                {
                    name: "YouTube",
                    url: "https://www.youtube.com/user/avfcofficial",
                    path:
                        "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
                },
                {
                    name: "TikTok",
                    url: "https://www.tiktok.com/@astonvilla",
                    path:
                        "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
                },
                {
                    name: "LinkedIn",
                    url: "https://www.linkedin.com/company/aston-villa-football-club",
                    path:
                        "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
                },
            ],
        };
    },
    props: {
        type: {
            type: String, // register | signin | help
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
$footer-bg: #290014;
$footer-bar-bg: #480024;
$footer-rule: #7a003d;
$footer-text: #fff;
$placeholder-bg: #1d6fe8;

.footer {
    margin: 50px 0 0;
    color: $footer-text;
    font-size: 16px;
    line-height: 1.4;
    text-align: center;
    background-color: $footer-bg;

    * {
        box-sizing: border-box;
    }

    a {
        color: inherit;
        text-decoration: none;

        &:hover {
            color: inherit;
        }
    }

    &__container {
        max-width: 1280px;
        margin: 0 auto;
    }

    &__shout {
        padding: 48px 20px 0;
        font-size: 18px;
    }

    &__heading {
        margin: 0 0 16px;
        font-size: 26px;
        font-weight: 700;

        @media screen and (min-width: 768px) {
            font-size: 32px;
        }
    }

    &__shout-text {
        margin: 24px 0 8px;
    }

    &__shout-link {
        display: inline-block;
        text-decoration: underline;

        &:hover {
            opacity: 0.75;
        }

        &:focus-visible {
            opacity: 0.75;
        }
    }

    &__partners {
        padding: 32px 0;
    }

    &__social {
        padding: 32px 16px;
        background-color: $footer-bar-bg;
    }

    &__legal {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 16px;
        font-size: 12px;
        background-color: $footer-bar-bg;
    }
}

.crest-rule {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 24px 16px;

    &__line {
        flex: 1 1 0;
        min-width: 8px;
        height: 0;
        margin: 24px 0;
        border-bottom: 2px solid $footer-rule;
    }

    &__crest {
        flex: 0 0 auto;
        width: auto;
        height: 96px;
    }
}

.partners {
    &__title {
        margin: 0;
        font-family: "Medula One", "effra", "Helvetica", "Arial", sans-serif;
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
        text-transform: uppercase;

        @media screen and (min-width: 768px) {
            font-size: 24px;
            line-height: 32px;
        }
    }

    &__list {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        gap: 16px;
        max-width: 768px;
        margin: 0 auto;
        padding: 8px 16px 16px;
        list-style: none;

        @media screen and (min-width: 400px) {
            gap: 24px;
        }
    }

    &__list--spread {
        justify-content: space-between;
    }

    &__item {
        display: flex;
        min-width: 0;
    }

    &__link {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 64px;
        transition: opacity 0.2s ease-in-out;

        @media screen and (min-width: 768px) {
            height: 80px;
        }

        &:hover {
            opacity: 0.75;
        }

        &:focus-visible {
            opacity: 0.75;
        }
    }

    &__list--large &__link {
        @media screen and (min-width: 768px) {
            height: 96px;
        }

        @media screen and (min-width: 1024px) {
            height: 128px;
        }
    }

    &__logo {
        display: block;
        width: auto;
        height: 100%;
        max-width: 100%;
        object-fit: contain;
    }

    &__placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 88px;
        height: 100%;
        padding: 4px;
        font-size: 10px;
        line-height: 1.2;
        background-color: $placeholder-bg;
    }
}

.social {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin: 0;
    padding: 0;
    list-style: none;

    @media screen and (min-width: 400px) {
        gap: 16px;
    }

    &__link {
        display: block;
        transition: opacity 0.2s ease-in-out;

        &:hover {
            opacity: 0.7;
        }

        &:focus-visible {
            opacity: 0.7;
        }
    }

    &__icon {
        display: block;
        width: 24px;
        height: 24px;
        fill: currentColor;
    }
}

.legal {
    &__links {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 8px 24px;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    &__link:hover {
        text-decoration: underline;
    }

    &__link:focus-visible {
        text-decoration: underline;
    }

    &__copyright {
        margin: 16px 0 0;
    }
}
</style>
